const { defineMessages } = require('@edx/frontend-platform/i18n');

const FEEDBACK_SUCCESS_MESSAGE = `
  Your feedback has been successfully saved for the course!
  Thank you for sharing your thoughts and contributing to our ongoing growth and improvement.
  We appreciate your participation and look forward to continuing to provide you with an exceptional learning experience in our courses!
`;

const FEEDBACK_ERROR_MESSAGE = `
  An error occurred while saving your feedback for the course.
  We apologize for the inconvenience. Please try again later and if the issue persists, kindly contact our support team for further assistance.
  Thank you for your patience.
`;

const MODAL_BODY_INTRO = `
  Congratulations on completing the course! We appreciate your effort and dedication.
  Now, we kindly request your feedback to help us improve.
  Your input is valuable in enhancing the learning experience for future students.
`;

const MODAL_BODY_THANKS = `
  Thank you for taking the time to share your thoughts and
  congratulations once again on your accomplishment!
`;

const messages = defineMessages({
  congratulationsTitle: {
    id: 'essentials.feedbackModal.congratulationsTitle',
    defaultMessage: 'Congratulations',
    description: 'Modal title',
  },
  bodyIntroduction: {
    id: 'essentials.feedbackModal.bodyIntroduction',
    defaultMessage: MODAL_BODY_INTRO,
    description: 'Modal body introduction.',
  },
  bodyThanks: {
    id: 'essentials.feedbackModal.bodyThanks',
    defaultMessage: MODAL_BODY_THANKS,
    description: 'Modal body thanks.',
  },
  rateTitle: {
    id: 'essentials.feedbackModal.rateTitle',
    defaultMessage: 'Rate this course',
    description: 'Rate section title',
  },
  content: {
    id: 'essentials.feedbackModal.content',
    defaultMessage: 'Content',
    description: 'Content string',
  },
  instructors: {
    id: 'essentials.feedbackModal.instructors',
    defaultMessage: 'Instructors',
    description: 'Instructors string',
  },
  recommendMessage: {
    id: 'essentials.feedbackModal.recommendMessage',
    defaultMessage: 'Would you recommend this course ?',
    description: 'Recommend message.',
  },
  floatingLabel: {
    id: 'essentials.feedbackModal.floatingLabel',
    defaultMessage: 'Leave us your comments',
    description: 'Feedback section label',
  },
  yes: {
    id: 'essentials.feedbackModal.yes',
    defaultMessage: 'Yes',
    description: 'Yes string',
  },
  no: {
    id: 'essentials.feedbackModal.no',
    defaultMessage: 'No',
    description: 'No string',
  },
  cancel: {
    id: 'essentials.feedbackModal.cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel string',
  },
  submit: {
    id: 'essentials.feedbackModal.submit',
    defaultMessage: 'Submit',
    description: 'Submit string',
  },
  errorTitle: {
    id: 'essentials.feedbackModal.errorTitle',
    defaultMessage: 'Something went wrong',
    description: 'Error title',
  },
  successMessage: {
    id: 'essentials.feedbackModal.successMessage',
    defaultMessage: FEEDBACK_SUCCESS_MESSAGE,
    description: 'Success message after submitting',
  },
  errorMessage: {
    id: 'essentials.feedbackModal.errorMessage',
    defaultMessage: FEEDBACK_ERROR_MESSAGE,
    description: 'Error message after submitting',
  },
  reviews: {
    id: 'essentials.feedbackCarousel.reviews',
    defaultMessage: 'Reviews',
    description: 'Review string',
  },
  publicMessage: {
    id: 'essentials.feedbackModal.publicMessage',
    defaultMessage: 'Would you like to make your feedback public ?',
    description: 'Public message.',
  },
});

export default messages;
